import { getStorage } from '@/utils/storage'
import { STORAGE_FLIGHTS_QUERY_TC } from '@/utils/train-storage'

export default {
  flightsQuery: getStorage(STORAGE_FLIGHTS_QUERY_TC) || {},
  flightsCities: [],
  flightsHotCities: [],
  cityAirports: [],
  airports: [],
  privacyList: {}, // 机票百川协议
  privacyVisible: false, // 协议弹窗
  privacyCb: null, // 同意协议后的回调函数
  flightsCouponData: {}, // 机票优惠券数据
  queryCardBtnText: '', // 机票运营文案
}
